import type { InventoryRow } from "@school-sales-ai/shared";

/**
 * A product's stock in the catalog row: read-only, with one button.
 *
 * **Stock is not catalog data**, and that is the decision most likely to be
 * undone by someone "finishing" the form. It changes hourly, and routing it
 * through the catalog's row saves would let a stale open form overwrite a
 * concurrent recount. The button posts to its own endpoint.
 *
 * "Sin control" rather than "0" when there is no row: the two mean different
 * things, and only one of them stops a sale.
 */
export function StockCell({
  row,
  disabled,
  onAdjust,
}: {
  row: InventoryRow | undefined;
  disabled?: boolean;
  onAdjust: () => void;
}): React.JSX.Element {
  const tracked = row?.onHand !== null && row?.onHand !== undefined;

  return (
    <div className="flex shrink-0 items-center gap-2 text-[12.5px]">
      {tracked ? (
        <span className="text-ink-600">
          <span className="font-medium text-ink-900">{row.available}</span> disponibles
          {row.reserved > 0 ? ` · ${row.reserved} apartadas` : ""}
        </span>
      ) : (
        <span className="text-ink-500">Sin control</span>
      )}
      <button
        type="button"
        onClick={onAdjust}
        disabled={disabled}
        className="rounded-lg border border-ink-200 px-2 py-1 text-[11.5px] font-medium text-ink-700 hover:bg-ink-050 disabled:opacity-40"
      >
        Ajustar
      </button>
    </div>
  );
}
